import type { ReactNode } from 'react'
import { ApiError } from '../lib/api'

/** Ladezustand als ruhige Zeile statt als springender Platzhalter. */
export function Loading({ what }: { what: string }) {
  return (
    <div className="empty">
      <span>{what} werden geladen …</span>
    </div>
  )
}

/** Fehler verständlich zeigen, ohne technische Details zu verstecken. */
export function ErrorBox({ error, what }: { error: unknown; what: string }) {
  const message =
    error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : 'Unbekannter Fehler'
  return (
    <div className="card" style={{ borderColor: 'var(--crit)' }}>
      <div className="card-body">
        <strong style={{ color: 'var(--crit)' }}>{what} konnten nicht geladen werden</strong>
        <div className="muted" style={{ marginTop: 6 }}>
          {message}
        </div>
      </div>
    </div>
  )
}

/** Leere Liste mit Hinweis, was als Nächstes zu tun ist. */
export function EmptyState({ title, hint, action }: { title: string; hint: string; action?: ReactNode }) {
  return (
    <div className="empty">
      <strong>{title}</strong>
      <span>{hint}</span>
      {action}
    </div>
  )
}
